angular.module('picmonic-common')
    .directive("groupBuyBanner", [function(){
        return {
            restrict: 'E',
            template: '<div ng-show="visible && ((now > 1530428399) || is_checkout) && !palife" class="group-buy-banner pls-gradient-sunrise pls-font-24 pls-font-raleway pls-font-weight-600 text-center p-t-1 p-b-1" style="position:relative;height: 54px;" ng-click="GroupBuyService.launch(marketId)">\
                <em class="pls-black" style="position: relative;top: 2px;">Buy as a group & save </em><a class="pls-btn pls-btn--white pls-orange m-l-2 hidden-xs"><span ng-hide="GroupBuyService.plans.$promise">Learn More</span><span ng-show="GroupBuyService.plans.$promise">Loading... <pls-loading-icon size="x-small"></pls-loading-icon></span></a>\
                <i class="pls-white pull-right material-icons m-r-2 group-buy-banner-close" style="position: absolute;top: 10px;right:0;" ng-click="hideBanner($event)">close</i>\
            </div>',
            replace: true,
            scope: {
                marketId: '<'
            },
            controller: ['$scope', '$cookies', '$state', '$stateParams', 'GroupBuyService', function($scope, $cookies, $state, $stateParams, GroupBuyService){
                $scope.GroupBuyService = GroupBuyService;
                $scope.palife = $stateParams.palife;
                $scope.now = Math.floor((new Date()).getTime() / 1000);
                $scope.visible = !parseInt($cookies.get('pls_user_group_buy_banner_visible'), 10);
                if ($stateParams.is_group_buy || $stateParams.no_banner) {
                    $scope.visible = false;
                }

                $scope.is_checkout = $state.current.name === 'app.store.checkout' ? 1 : 0;

                $scope.hideBanner = function($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    $scope.visible = false;
                    var expires = new Date();
                    expires.setTime(expires.getTime() + (24*60*60*1000));
                    $cookies.put('pls_user_group_buy_banner_visible', 1, {expires:expires});
                };
            }]
        };
    }]);